<template>
  <div class="container">
    <!-- <h1>{{ msg }}</h1> -->
    <b-card-group deck style="margin-top:2rem;">
      <b-card
        header-text-variant="primary"
        :title="$t('software')"
        img-src="Screenshot-SMF.png"
        img-height="auto"
        img-width="538px"
        img-bottom
        class="shadow">
        <b-card-text>{{ $t('txt-03')}}</b-card-text>
        <b-button to="/software" variant="outline-primary">{{ $t('txt-01')}}</b-button>
      </b-card>

      <b-card
        header-text-variant="success"
        :title="$t('hosting')"
        img-src="Screenshot-hosting.png"
        img-bottom
        class="shadow">
        <b-card-text>{{ $t('txt-04')}}</b-card-text>
        <b-button to="/hosting" variant="outline-success">{{ $t('txt-01')}}</b-button>
      </b-card>
    </b-card-group>

    <b-card-group deck style="margin-top:2rem; margin-bottom:2rem;">
      <b-card
        header-text-variant="danger"
        :title="$t('hardware')"
        img-src="smgw-lte.png"
        img-bottom
        class="shadow">
        <b-card-text>Smart Meter Gateway (SMGW) - {{ $t('txt-05') }}</b-card-text>
        <b-button to="/hardware" variant="outline-danger">{{ $t('txt-01')}}</b-button>
      </b-card>

      <b-card
        header-text-variant="secondary"
        :title="$t('consulting')"
        img-src="logo-consulting.svg"
        img-bottom
        class="shadow">
        <b-card-text>{{ $t('txt-02')}}</b-card-text>
        <b-button to="/consulting" variant="outline-secondary">{{ $t('txt-01')}}</b-button>
      </b-card>
    </b-card-group>

  </div>
</template>

<script>
// import SL from '@/components/SelectLanguage'

export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
